import { useEffect } from "react"

const GTM_ID = process.env.REACT_APP_GTM_ID

export const useGTM = () => {
  useEffect(() => {
    if (!GTM_ID) return
    if (window.dataLayer) return // prevent re-initialization

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    })

    // Create script tag
    const script = document.createElement("script")
    script.async = true
    script.src = `https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`
    document.head.appendChild(script)

    return () => {
      // Optional cleanup if needed (e.g., for single-page apps)
      document.head.removeChild(script)
    }
  }, [])
}
